'use strict';
var DataPointType;
(function (DataPointType) {
    DataPointType["Chip"] = "chip";
    DataPointType["Value"] = "value";
    DataPointType["KeyValue"] = "kv";
})(DataPointType || (DataPointType = {}));
export default DataPointType;
